export default "__VITE_ASSET__CfF2tnNg__"